<ng-container *t="let t">
    <div class="details-wrapper">
        <!-- header with supplier name, additional details button, supplier search -->
        <div class="header-title">
            <div class="title" *ngIf="showAdditionalDetailsLink">
                <h2 [hidden]="!supplierCode"
                    >{{ profile?.supplierDetails?.supplierName }} - {{ profile?.supplierDetails?.supplierCode }}</h2
                >
            </div>
            <div
                (click)="openDetails()"
                class="additional-details"
                *ngIf="availableFields?.length > 0 && showAdditionalDetailsLink"
            >
                <div
                    class="additional-details-title"
                    i18n="@@e323dd89de92618b6f954d456d2358c1f176d6bf"
                    t="e323dd89de92618b6f954d456d2358c1f176d6bf"
                    >Additional Details</div
                >
                <tsl-icon class="icon-blue">{{ panelOpenState ? 'expand_less' : 'expand_more' }}</tsl-icon>
            </div>
            <div class="supplier-selection" *ngIf="userDetails?.isTeslaUser">
                <!-- Autocomplete for Tesla users -->
                <div class="search-container">
                    <div class="search-child">
                        <h5
                            class="search-text"
                            i18n="@@5055094cf6352ffaa030d2250859ce4099b57e2d"
                            t="5055094cf6352ffaa030d2250859ce4099b57e2d"
                            >Search Supplier</h5
                        >
                    </div>
                    <div class="search-child">
                        <div class="searchContainer">
                            <input
                                tslInput
                                autocomplete="off"
                                minlength="3"
                                maxlength="25"
                                tPlaceholder="5055094cf6352ffaa030d2250859ce4099b57e2d" i18n-placeholder="@@5055094cf6352ffaa030d2250859ce4099b57e2d"
                                placeholder="Search Supplier"
                                [formControl]="searchSupplier"
                                [tslAutocomplete]="supplierAutocomplete"
                                class="searchBox"
                            />
                            <tsl-icon class="searchIcon">search</tsl-icon>

                            <tsl-autocomplete
                                #supplierAutocomplete="tslAutocomplete"
                                [displayWith]="supplierAutocompleteDisplay"
                                (optionSelected)="onSelectSupplier($event.option)"
                            >
                                <tsl-option *ngFor="let supplier of obSupplierList$ | async" [value]="supplier">
                                    {{ supplier.supplierCode }} - {{ supplier.supplierName }}</tsl-option
                                >
                            </tsl-autocomplete>
                        </div>
                    </div>
                </div>
            </div>
            <div class="supplier-selection" *ngIf="userDetails?.isSupplier">
                <!--Dropdown for Suppliers-->
                <tsl-select
                    fullWidth
                    tPlaceholder="5055094cf6352ffaa030d2250859ce4099b57e2d" i18n-placeholder="@@5055094cf6352ffaa030d2250859ce4099b57e2d"
                    placeholder="Search Supplier"
                    [(ngModel)]="newSupplier"
                    contentWidth="content"
                    [ngModelOptions]="{ standalone: true }"
                    (selectionChange)="onChangeSupplier()"
                >
                    <tsl-option
                        *ngFor="let supplier of userDetails?.supplierContact?.supplierMaps"
                        [value]="supplier.supplierCode"
                        >{{ supplier.supplierCode }} - {{ supplier.supplierName }}
                    </tsl-option>
                </tsl-select>
            </div>
        </div>
        <div *ngIf="panelOpenState && showAdditionalDetailsLink" class="details">
            <!-- TODO: find some way to render this with common component, dont repeat the code -->
            <div class="header-content" *ngIf="supplierCode">
                <div fxFlex>
                    <div class="cl-1">
                        <div class="row headerRow">
                            <div class="column" fxFlex="25" *ngIf="availableFields.includes('DBA')">
                                <label
                                    class="label"
                                    i18n="@@912911094739ef6fbc483c230924e1f21fcbba8c"
                                    t="912911094739ef6fbc483c230924e1f21fcbba8c"
                                    >DBA Name</label
                                >
                                <br /><br />
                                <div class="data" *ngIf="profile?.supplierDetails?.dba; else empty">
                                    {{ profile?.supplierDetails?.dba }}</div
                                >
                            </div>
                            <div class="column" fxFlex="25" *ngIf="availableFields.includes('Website')">
                                <label
                                    class="label"
                                    i18n="@@afb605e735bef0cdd46dbff3c3d2be15960cdc2b"
                                    t="afb605e735bef0cdd46dbff3c3d2be15960cdc2b"
                                    >Website</label
                                >
                                <br /><br />
                                <div class="data" *ngIf="profile?.supplierDetails?.website; else empty">
                                    <a
                                        tsl-button
                                        ghost
                                        target="_blank"
                                        rel="external"
                                        [href]="getSupplierWebsite(profile?.supplierDetails?.website)"
                                        >{{ profile?.supplierDetails?.website }}</a
                                    >
                                </div>
                            </div>

                            <div class="column" fxFlex="25" *ngIf="availableFields.includes('Serialization Code')">
                                <label
                                    class="label"
                                    i18n="@@bf036bb72bd75a02e09fb18262e60549264c28eb"
                                    t="bf036bb72bd75a02e09fb18262e60549264c28eb"
                                    >Serialization Code</label
                                >
                                <br /><br />
                                <div class="data" *ngIf="profile?.supplierDetails?.serializationCode; else empty">
                                    {{ profile?.supplierDetails?.serializationCode }}</div
                                >
                            </div>
                            <div class="column" fxFlex="25" *ngIf="availableFields.includes('Scorecard')">
                                <label
                                    class="label"
                                    i18n="@@7c9457402ac6763a66264bb1a71873bbaca0366c"
                                    t="7c9457402ac6763a66264bb1a71873bbaca0366c"
                                    >Scorecard</label
                                >
                                <br /><br />
                                <div class="data" *ngIf="profile?.scoreCard > 0; else empty">
                                    <a
                                        tsl-button
                                        ghost
                                        target="_blank"
                                        rel="noreferrer"
                                        [href]="supplierScoreRenderer(profile)"
                                        >{{ profile?.scoreCard }}</a
                                    >
                                </div>
                            </div>
                            <div class="column" fxFlex="25" *ngIf="availableFields.includes('Site Assessment Score')">
                                <label
                                    class="label"
                                    i18n="@@92e731b00cdf53a52689f2c6c56b1124f5fdee8e"
                                    t="92e731b00cdf53a52689f2c6c56b1124f5fdee8e"
                                    >Site Assessment Score</label
                                >
                                <br /><br />
                                <div class="data">
                                    <a tsl-button ghost target="_blank" rel="noreferrer" [href]="sqaUrl"
                                        >{{ profile?.supplierSqeMapping?.assessmentScore / 100 | percent
                                        }}{{
                                            profile?.supplierSqeMapping?.confidenceLevel
                                                ? ' (' + profile?.supplierSqeMapping?.confidenceLevel + ')'
                                                : ''
                                        }}</a
                                    >
                                </div>
                            </div>
                            <div class="column" fxFlex="25" *ngIf="availableFields.includes('CTPAT Score')">
                                <label
                                    class="label"
                                    i18n="@@cee057da09ee29a4654b624f3ba50c356d6b7a0a"
                                    t="cee057da09ee29a4654b624f3ba50c356d6b7a0a"
                                    >Security (CTPAT) Score</label
                                >
                                <br /><br />
                                <div class="data" *ngIf="profile?.ctpatData?.score > 0; else empty">
                                    <a tsl-button ghost target="_blank" rel="noreferrer" [href]="ctpatUrl"
                                        >{{ profile?.ctpatData?.score }} ({{ profile?.ctpatData?.assessmentYear }})
                                    </a>
                                </div>
                            </div>

                            <div class="column" fxFlex="25" *ngIf="availableFields.includes('Primary Contact')">
                                <label class="label">
                                    <span i18n="@@PrimaryContact" t="PrimaryContact">Primary Contact</span>
                                    <tsl-icon
                                        tooltip="Primary account can create and edit critical and secondary contacts, including designate Portal access to other users. It is the organization’s primary authorizer for all issues/contacts." 
                                        i18n-tooltip="@@4644457741504477910" #contactInfoIcon tslTooltip="{{ t('4644457741504477910', contactInfoIcon) }}"
                                    >
                                        info</tsl-icon
                                    >
                                </label>
                                <br /><br />
                                <div class="data" *ngIf="primaryContact; else empty">{{ primaryContact }}</div>
                            </div>

                            <div class="column" fxFlex="25" *ngIf="availableFields.includes('Profile Admin')">
                                <label class="label">
                                    <span
                                        i18n="@@4108f99809528e0dfae0d336284c9f479b60dffb"
                                        t="4108f99809528e0dfae0d336284c9f479b60dffb"
                                        >Profile Admin</span
                                    >
                                    <tsl-icon
                                        tooltip="Profile Admin can be assigned to assist the Primary Contact to add, edit, and delete secondary contacts within the Tesla Supplier Portal." 
                                        i18n-tooltip="@@3790301477161980515" #adminInfoIcon tslTooltip="{{ t('3790301477161980515', adminInfoIcon) }}"
                                    >
                                        info</tsl-icon
                                    >
                                </label>
                                <br /><br />
                                <div class="data" *ngIf="profileAdmin; else empty">{{ profileAdmin }}</div>
                            </div>

                            <div class="column" fxFlex="25" *ngIf="availableFields.includes('Supplier Operations Support')">
                                <label
                                    class="label"
                                    i18n="@@5104fa7632f5ab119938a01a185fb53924f44000"
                                    t="5104fa7632f5ab119938a01a185fb53924f44000"
                                    >Supplier Operations Support
                                </label>
                                <br /><br />
                                <div class="data" *ngIf="supplierSOS; else empty"
                                    >{{ supplierSOS }}
                                    <a href="mailto:{{ supplierSOSEmail }}"> ({{ supplierSOSEmail }}) </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-template #empty>
                        <tsl-icon class="additional-details-child">maximize</tsl-icon>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</ng-container>
